import React, {useState} from 'react'
import TruncateServer from './truncate-server.component'
import Loadable from "@loadable/component"

const TruncateClient = Loadable(() => import('./truncate-client.component'))

const Truncate = ({children}) => {
	return (
		<TruncateClient fallback={<TruncateServer>{children}</TruncateServer>}>{children}</TruncateClient>
	)
}

export default Truncate;